<div class="container" fxLayout="column" fxLayoutGap="10px">
    <div fxFlex>
        <div>
            <h1 style="font-weight: bold; text-align: center;">Menu</h1>
            <hr>
        </div>

    </div>

    <div fxFlex *ngIf="dishes" [@expand]>
        <mat-grid-list cols="2" rowHeight="250px">
            <mat-grid-tile *ngFor="let dish of dishes" [routerLink]="['/dishdetail', dish.id]" appHighlight>
                <img height="200px " src="{{BaseURL + dish.image}} " alt={{dish.name}}>
                <mat-grid-tile-footer>
                    <h1>{{dish.name | uppercase}}</h1>
                </mat-grid-tile-footer>
            </mat-grid-tile>
        </mat-grid-list>
    </div>
    <div [hidden]="dishes || errMess ">
        <mat-spinner></mat-spinner>
        <h4>Loading . . . Please Wait</h4>
    </div>
    <div fxFlex *ngIf="errMess ">
        <h2 style="text-align: center; ">Error</h2>
        <h4>{{errMess}}</h4>
    </div>

</div>